import {
  _InitForm,
  _ChangeField,
  //_SetFieldDirty,
  _SetFieldTouched,
  _WatchField,
  _FocusField,
  _ResetForm,
  _RemoveForm,

  /*_SetFormDirty,*/
  _ValidateDataType,
  _ValidateSchema,
  _ValidateList,
  _FillListControl,
} from "./library/forms/actions"

import {
  _Navigate,
  _Logout,
  _InitApp,
  _RehydrateApp,
  _GetFile,
  _SetPortalTestingMode,
  _SetLanguage,
  _SetLastScrollPosition,
} from "./global/actions"

import {
  _AddSnack,
  _RemoveSnack,
  _PlaceSnack,
  _ClearSnack,
  _ReplaceSnackContent,
} from "./library/snack/actions"

import {
  _LongRunningProcessEnd,
  _LongRunningProcessStart,
} from "./library/longrunningprocesstracker/longrunningprocesstracker"

import {
  _ModalDialogOpen,
  _OkDialog,
  _OkCancelDialog,
  _DialogOpen,
  _DialogClose,
  _DialogSetLock,
} from "./library/dialog/actions"
let dialog = {
  _DialogOpen,

  _DialogClose,
  _DialogSetLock,
  _ModalDialogOpen,
  _OkDialog,
  _OkCancelDialog,
}

let form = {
  _InitForm,
  _ResetForm,

  _RemoveForm,
  _ChangeField,
}

import {
  _DialogChanged,
  _DialogDefaultChanged,
  _TableRefresh,
  _TableInit,
  _TableRebuild,
  _TableSelectRow,
  _TableSelectHeader,
  _TableSort,
  _TableFilter,
  _TableFilterSelected,
  _TableSetPage,
  _TableDeleteRow,
  _TableCopyRow,
  _TableEditRow,
  _TableSelectEndRow,
  _OpenTableRowHeaderMenu,
  _TableSelectAll,
  _TableEditSaveRow,
  _TableDirectSaveRow,
  _TableEditClose,
  _TableMoreRow,
  _TableViewRow,
  _TableCloseViewRow,
  _TableAddRow,
  _TableDeleteRowFromData,
  _TableMultipleEditRow,
  _TableMultipleCustomFunction,
  _TableRefreshDataFromServer,
  _TableSelectCustomSort,
  _TableSelectFilterSort,
  _TableSelectCustomFilter,
  _TableSelectAttributeFilter,
  _TableSelectColumnFilter,
  _TableSelectColumnRangeFilter,
  _TableSetViewTab,
  _TableOfflineRetryDeleteRow,
  _TableOfflineRetrySaveRow,
  _TableOfflineHandler,
} from "./library/actions"
import { SYSAction, SYSScreen } from "."
import { ScreenCurrentState } from "./library/screenapi"
import { Data } from "./dataapi"

let navigation = { _Navigate }

//let indicator = { SetIndicatorOpen, SetIndicatorClose }

let table = {
  _TableRefresh,
  _TableInit,
  _TableRebuild,
  _TableSelectRow,
  _TableEditRow,

  _OpenTableRowHeaderMenu,
  _TableDeleteRow,
  _TableEditClose,

  _TableRefreshDataFromServer,
  _TableSort,
  _TableFilter,

  _TableAddRow,
  _TableDirectSaveRow,
  _TableSetViewTab,
}

export const _CancelRowFn: SYSAction<
  {
    fnKey: string
    clientId: string
    tableDefId: string
  },
  Promise<void>
> = async ({ fnKey, clientId, tableDefId }, { global }) => {
  await Data("users/cancelrowfn", { fnKey, clientId, tableDefId })
}

let internal = {
  _CancelRowFn,
  _SetLastScrollPosition,
  _PlaceSnack,
  _ClearSnack,
  _AddSnack,
  _RemoveSnack,
  _ReplaceSnackContent,
  _DialogChanged,
  //DialogClosed,
  _DialogDefaultChanged,
  _TableSelectHeader,
  _TableFilterSelected,
  _TableSetPage,
  _TableCopyRow,
  _TableDeleteRow,
  _TableAddRow,
  _TableEditRow,
  _TableSelectEndRow,
  _TableSelectAll,
  _TableEditSaveRow,
  _TableDirectSaveRow,
  _TableMoreRow,
  _TableViewRow,
  _TableCloseViewRow,
  _TableDeleteRowFromData,

  //_TableMultipleCopyRow,
  _TableMultipleEditRow,
  _TableMultipleCustomFunction,
  _TableSelectCustomSort,
  _TableSelectFilterSort,
  _TableSelectCustomFilter,
  _TableSelectAttributeFilter,
  _TableSelectColumnFilter,
  _TableSelectColumnRangeFilter,
  _TableOfflineRetryDeleteRow,
  _TableOfflineRetrySaveRow,
  _TableOfflineHandler,
  _InitApp,
  _RehydrateApp,
  _GetFile,

  _SetLanguage,
  _SetPortalTestingMode,

  _ChangeField,
  //SetField,
  _WatchField,
  _FocusField,
  _SetFieldTouched,
  //SetFormValid,
  _ValidateDataType,

  /*_SetFormDirty,*/
  //_SetFieldDirty,
  _ValidateSchema,
  _ValidateList,
  _FillListControl,
  _LongRunningProcessEnd,
  _LongRunningProcessStart,
}
const _ScreenSetLock: SYSAction<{
  screen: SYSScreen
  locked: boolean
  instance: string
}> = (value, { global }) => {
  let state = global.getState()
  let instance = value.instance
  if (instance === undefined) {
    instance = <string>value.screen
  }
  state.ovl.screens.screens[value.screen].instance[instance].disabled =
    value.locked
}
let screen = { _ScreenSetLock }
let user = { _Logout }
export let ovlActions = {
  /*indicator,*/ navigation,
  internal,
  dialog,
  screen,
  form,
  table,
  user,
}
